import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

const selectSelf = (state: ReduxState) => state.counters;

export const selectCounters = createSelector(selectSelf, (counters) => counters);
